(function () {
  function init(scope) {
    scope.querySelectorAll('[data-sbs-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const stage = gallery.querySelector('[data-gallery-stage]');
      const expand = gallery.querySelector('[data-gallery-expand]');
      const dialog = gallery.querySelector('[data-image-dialog]');
      const zoomImage = dialog.querySelector('[data-zoom-image]');
      const magnify = dialog.querySelector('[data-image-magnify]');
      let previousOverflow = '';
      function openImage() {
        const image = stage.querySelector('img');
        if (!image || stage.querySelector('video,iframe')) return;
        zoomImage.src = image.currentSrc || image.src;
        zoomImage.alt = image.alt;
        dialog.classList.remove('is-magnified');
        magnify.textContent = 'Zoom in';
        magnify.setAttribute('aria-pressed', 'false');
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
      }
      gallery.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-cro-media]');
        if (thumbnail && thumbnail.getAttribute('aria-current') !== 'true') {
          stage.querySelectorAll('video').forEach(video => video.pause());
          const player = Array.from(gallery.querySelectorAll('template[data-cro-player]')).find(item => item.dataset.croPlayer === thumbnail.dataset.croMedia);
          if (player) stage.replaceChildren(player.content.cloneNode(true));
          else {
            const source = thumbnail.querySelector('img');
            const image = document.createElement('img');
            image.src = source.dataset.large || source.src;
            image.alt = source.alt;
            stage.replaceChildren(image);
          }
          expand.hidden = Boolean(player);
          gallery.querySelectorAll('[data-cro-media]').forEach(item => item.setAttribute('aria-current', String(item === thumbnail)));
        }
        if (event.target.closest('[data-gallery-expand]') || (event.target.tagName === 'IMG' && event.target.parentElement === stage)) openImage();
      });
      dialog.querySelector('[data-image-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; expand.focus({preventScroll:true}); });
      magnify.addEventListener('click', () => {
        const enlarged = dialog.classList.toggle('is-magnified');
        magnify.textContent = enlarged ? 'Fit image' : 'Zoom in';
        magnify.setAttribute('aria-pressed', String(enlarged));
      });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stage.querySelectorAll('video').forEach(video => video.pause()); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
